(() => {
  const init = () => {
    const header = document.querySelector('#header-component');
    if (!header || header.dataset.aurelleNavigation) return;
    header.dataset.aurelleNavigation = 'ready';
    const mobile = matchMedia('(max-width: 749px)');
    let previous = Math.max(0, window.scrollY);
    let distance = 0;
    let direction = 0;
    let frame = 0;
    const update = () => {
      frame = 0;
      const y = Math.max(0, window.scrollY);
      const delta = y - previous;
      previous = y;
      if (!mobile.matches) {
        header.removeAttribute('data-aurelle-scroll');
        return;
      }
      const open = !!header.querySelector('header-drawer > details[open]');
      if (y < 12 || open || header.contains(document.activeElement)) {
        header.dataset.aurelleScroll = y < 12 ? 'top' : 'up';
        distance = 0;
        return;
      }
      const nextDirection = Math.sign(delta);
      if (nextDirection && nextDirection !== direction) distance = 0;
      if (nextDirection) direction = nextDirection;
      distance += Math.abs(delta);
      if (distance >= 10) {
        header.dataset.aurelleScroll = direction > 0 && y > header.offsetHeight + 36 ? 'down' : 'up';
        distance = 0;
      }
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    window.addEventListener('scroll', schedule, { passive: true });
    mobile.addEventListener('change', schedule);
    header.addEventListener('focusin', schedule);
    header.querySelectorAll('header-drawer > details').forEach(details => {
      details.addEventListener('toggle', () => {
        details.classList.toggle('menu-open', details.open);
        details.querySelector('summary')?.setAttribute('aria-expanded', String(details.open));
        if (details.open) header.dataset.aurelleScroll = 'up';
        schedule();
      });
    });
    header.addEventListener('pointerdown', event => {
      const item = event.target.closest('.menu-drawer a, .menu-drawer button, .menu-drawer summary');
      if (!item || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      const box = item.getBoundingClientRect();
      const ripple = document.createElement('span');
      ripple.className = 'aurelle-tap-wave';
      ripple.style.left = `${event.clientX - box.left}px`;
      ripple.style.top = `${event.clientY - box.top}px`;
      item.append(ripple);
      ripple.addEventListener('animationend', () => ripple.remove(), { once: true });
    });
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();

